import { useTranslation } from 'react-i18next';
import { textColor } from '../../theming';
import { deltaTone } from '../../utils/vinExtraction';
import { mutedSmallStyle, visuallyHiddenStyle } from './vinExtractionStyles';
import { useNumberFormat } from './useNumberFormat';

const ARROWS = { up: '▲', down: '▼' };

const TONE_COLORS = { good: textColor.success, bad: textColor.error, neutral: textColor.secondaryAlt };

const deltaAmount = (t, magnitude, unit) => {
    if (unit === 'pp') return t('stats.delta.pp', { value: magnitude });
    return `${magnitude}%`;
};

/** "▲ 12.4% vs prev. 24h", coloured by meaning; unit 'percent' or 'pp'. */
const StatDeltaLine = ({ delta, downIsGood, unit, period }) => {
    const { t } = useTranslation('vinExtraction');
    const { oneDecimal } = useNumberFormat();
    const periodLabel = t(`stats.period.${period}`);

    // nothing to compare with, or nothing in the window before (a "new" change): no arrow, no colour (SC-QA-102)
    if (!delta || delta.value === null) return <span style={mutedSmallStyle}>{t('stats.delta.noPrevious')}</span>;

    const magnitude = oneDecimal(Math.abs(delta.value));
    const amount = deltaAmount(t, magnitude, unit);
    const arrow = ARROWS[delta.direction];

    return (
        <span
            data-testid="vin-stat-delta"
            style={{ ...mutedSmallStyle, color: TONE_COLORS[deltaTone(delta, { downIsGood })] }}
        >
            {arrow && (
                <>
                    <span aria-hidden="true">{arrow} </span>
                    <span style={visuallyHiddenStyle}>{t(`stats.delta.${delta.direction}`)} </span>
                </>
            )}
            {amount} {t('stats.delta.vsPrev', { period: periodLabel })}
        </span>
    );
};

export default StatDeltaLine;
